import React, { useState, useRef, useEffect } from "react";
import { Badge } from 'primereact/badge';
import { Tooltip } from 'primereact/tooltip';
import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from 'primereact/avatargroup';
import { Button } from 'primereact/button';
import { getSocket } from '../../context/socket';
import { useAuth } from '../../context/AuthContext';
import { VscFlame } from "react-icons/vsc";
import moment from 'moment-timezone';
import { Col, Row, Card, } from 'react-bootstrap';
const Archived_tasks = ({ boardId, onClose }) => {
    const { userId, role } = useAuth();
    const socket = getSocket();

    const [archivedCards, setArchivedCards] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (socket && userId && role) {
            socket.emit('fetchArchivedCards', { user_id: userId, role });

            socket.on('archivedCardsFetched', (cards) => {
                setArchivedCards(cards);
                setLoading(false);
            });

            socket.on('fetchArchivedCardsError', (error) => {
                console.error(error.message);
                setLoading(false);
            });

            return () => {
                socket.off('archivedCardsFetched');
                socket.off('fetchArchivedCardsError');
            };
        }
    }, [socket, userId, role]);

    const formatDate = (date) => {
        return moment(date).format('DD MMM YYYY');
    };

    if (loading) {
        return <div>Loading archived tasks...</div>;
    }

    const handleArchiveCard = (cardId) => {
        if (!cardId || !boardId) return;
        socket.emit("toggleCardActiveStatus", {
            card_id: cardId,
            is_active: true, // false = archived
            board_id: boardId
        });
        onClose();
    };
    return (
        <Row className="mx-0">
            {/*---Right_part--- */}
            <Col lg={12} md={12} sm={12} className="p-0 right_partD">
                <Card className="shadow-0 p-0">
                    <Card.Header className="px-0 border-0">
                        <h5>Archieved Tasks</h5>
                    </Card.Header>
                    <Card.Body className="px-0 pt-0">

                        {archivedCards.length === 0 ? (
                            <p>No archived tasks found.</p>
                        ) : (
                            <div className="task-container">
                                {archivedCards.map((task, index) => (
                                    <div
                                        key={task.card_id}
                                        className={`board-task 
                                            ${task.missed_deadline ? "task-red" : "task-green"} 
                                            ${task.priority === 'Urgent' ? "example-1" : ""}`}
                                    >

                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <div className="d-flex justify-content-start align-items-center mb-1">
                                                <p
                                                    className={`mb-0 badge ${task.priority === "Urgent" || task.priority === "High"
                                                        ? "bg-danger"
                                                        : task.priority === "Medium"
                                                            ? "bg-warning"
                                                            : task.priority === "Low"
                                                                ? "bg-info"
                                                                : "bg-secondary"
                                                        }`}
                                                >
                                                    {task.priority || 'N/A'}
                                                </p>

                                                {task.missed_deadline && (
                                                    <div className="ms-2" style={{ position: "relative" }}>
                                                        <VscFlame
                                                            data-pr-tooltip="Deadline Missed"
                                                            data-pr-position="left"
                                                            className="missed-deadline-icon"
                                                            style={{
                                                                fontSize: "1.5rem",
                                                                color: "red",
                                                                marginRight: "auto",
                                                            }}
                                                        />
                                                        <Tooltip target=".missed-deadline-icon" />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="d-flex justify-content-end align-items-center mb-1">
                                                <Button title="Restore" severity="danger" icon="pi pi-undo" className="border-0" text onClick={() => handleArchiveCard(task.card_id)} />
                                            </div>
                                        </div>
                                        <p className="mb-0">
                                            <small><b>Task Name:</b> {task.title || "Untitled Task"}</small>
                                        </p>

                                        <div className="d-flex justify-content-between align-items-center border-top mt-2 pt-2">
                                            <small style={{fontSize: '12px'}}>
                                                <i style={{fontSize: '12px'}} className="pi pi-calendar"></i> {formatDate(task.createdAt)} - {formatDate(task.dueDate)}
                                            </small>

                                            <AvatarGroup>
                                                {task?.members?.map((member) => {
                                                    const fullName = `${member.first_name} ${member.last_name}`;

                                                    return (
                                                        <React.Fragment key={member.id}>
                                                            <Tooltip target={`#avatar-${member.user_id}`} content={fullName} position="left" />
                                                            <Avatar
                                                                id={`avatar-${member.user_id}`}
                                                                image={member?.profileImage?.image_url || 'https://primefaces.org/cdn/primereact/images/avatar/xuxuefeng.png'}
                                                                shape="circle"
                                                                title={fullName}
                                                            />
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </AvatarGroup>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </Card.Body>
                </Card>
            </Col>
        </Row >
    );
};


export default Archived_tasks;
